import React from "react";
import ReactDOM from "react-dom/client";
import { ToastContainer } from "react-toastify";
import { BrowserRouter as Router } from "react-router-dom";

import "./index.css";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { DriverBidsProvider } from "./hooks/useExistingBid";

import "react-toastify/dist/ReactToastify.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <AuthProvider>
      <DriverBidsProvider>
        <App />
        <ToastContainer hideProgressBar />
      </DriverBidsProvider>
    </AuthProvider>
  </Router>
);
